export default __webpack_public_path__ + "static/media/qb_icon.1f137040.png";